class ColumnText extends HTMLElement {
	constructor() {
		super();
		const toggles = this.querySelectorAll('.js-column-text-toggle');
		toggles.forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault();
				if (window.innerWidth < 768) {
					const target = this.querySelector(toggle.getAttribute('href'));
					toggle.classList.toggle('is-active');
					if (target.classList.contains('is-show')) {
						target.style.maxHeight = target.scrollHeight + 'px';
						setTimeout(function () {
							target.classList.remove('is-show');
							target.style.maxHeight = null;
						}, 1);
					} else {
						target.style.maxHeight = target.scrollHeight + 'px';
						setTimeout(function () {
							target.classList.add('is-show');
							target.style.maxHeight = null;
						}, 200);
					}
				}
			});
		});
	}
}

customElements.define('column-text', ColumnText);
